import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CurrencyContext } from '../config/CurrencyContext';
import Translations from '@h/translation';
import { TranslationContext } from '@c/Translations';
import { PaymentContextProvider } from '@showclix-shared/Payment/contexts/PaymentContext';
import EmailOptOutContainer from 'checkout/views/checkout/containers/EmailOptOutContainer';
import QuestionOptInContainer from 'checkout/views/checkout/containers/QuestionOptInContainer';
import TermsOfServiceContainer from "checkout/views/checkout/containers/TermsOfServiceContainer";
import StepActionContainer from 'checkout/views/checkout/containers/StepActionContainer';
import LocalizedAddress from 'checkout/views/member/components/LocalizedAddress';
import InsuranceContainer from 'checkout/views/insurance/containers/InsuranceContainer';

class EmbeddedComponentWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.t = new Translations(this.props.apiUrl);
        this.t.init('en_US', props.translations);
    }

    render() {
        return (
            <TranslationContext.Provider value={this.t}>
                <PaymentContextProvider value={{
                    TranslationContext,
                    LocalizedAddress,
                    StepAction: StepActionContainer,
                    Insurance: <InsuranceContainer />,
                    OptInsOuts: (
                      <>
                        <TermsOfServiceContainer />
                        <EmailOptOutContainer />
                        <QuestionOptInContainer />
                      </>
                    ),
                }}>
                    <CurrencyContext.Provider value={this.props.currencyConfig}>
                        {this.props.children}
                    </CurrencyContext.Provider>
                </PaymentContextProvider>
            </TranslationContext.Provider>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        currencyConfig: state.ui.currencyConfig,
    }
}

export default connect(mapStateToProps)(EmbeddedComponentWrapper);
